// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tip-dialog[data-v-82958ef0] .el-dialog__body {\n  padding: 20px 20px 15px;\n}\n.tip-dialog[data-v-82958ef0] .el-dialog__footer {\n  text-align: center;\n}\n.tip-dialog .title[data-v-82958ef0] {\n  font-size: 17px;\n  font-weight: bold;\n  text-align: center;\n}\n.tip-dialog .tip-content-wrap[data-v-82958ef0] {\n  margin-bottom: 10px;\n}\n.tip-dialog .dialog-footer[data-v-82958ef0] {\n  display: flex;\n  justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
